// Sport Energy Profile — atlet-profil (Fase 4.9.0)
//
// FASE 4.9.0 (jun 2026): sweatConditions — vejret under svedtesten
// ('koldt' | 'koeligt' | 'varmt') gemmes som kontekst sammen med
// tallet. Vejret aendrer ikke beregningen, kun forstaaelsen: et tal
// maalt i varme gaelder varme dage. setSweatRate tager en valgfri
// tredje parameter; clearSweatRate rydder ogsaa konteksten.
//
// FASE 4.8.0 (jun 2026): Natrium udvidet til TRE niveauer —
// 'lav' | 'normal' | 'salt' — så screeningen på svedtest-siden
// matcher race-kittets tre radioer (450/650/1000 mg/L) 1:1.
// Nye helpers: setSodium(level|null). Skemaet (FIELDS) er uændret.
//
// Lille selvstændigt modul der ejer atletens lokale profil:
// målt svedtab (fra svedtesten eller guidens slider) og — senere —
// mave-tolerance og præferencer til race-kit-byggeren (R4) og
// træningsberegneren (R6).
//
// Principper:
// - localStorage, versioneret skema, INGEN TTL — et målt svedtab
//   forældes ikke af kalenderen, kun af en ny måling.
// - Eksplicit slet (clear / clearSweatRate) — atleten ejer sine tal.
// - Hvidlistede felter: ukendte nøgler afvises stille, så skemaet
//   ikke skrider over tid.
// - Defensivt hele vejen: privat browsing eller blokeret storage
//   må aldrig vælte siden — alt fejler til null/false.
//
// Ingen afhængigheder. Loades før guide-runtime, men guiden
// degraderer pænt hvis modulet mangler.

(function () {
  'use strict';

  var KEY = 'seg_athlete_profile_v1';
  // FASE 4.8.0: sodium ('lav'|'normal'|'salt') — skrives af natrium-
  // screeningen på svedtest-siden, læses af race-kit byggeren.
  var FIELDS = ['sweatRateMl', 'sweatSource', 'sweatMeasuredAt', 'sweatConditions', 'sodium', 'stomach', 'caffeine'];

  function validSweat(ml) {
    return typeof ml === 'number' && !isNaN(ml) && ml >= 400 && ml <= 2500;
  }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      if (!p || p.v !== 1) return null;
      return p;
    } catch (e) { return null; }
  }

  function write(p) {
    try {
      localStorage.setItem(KEY, JSON.stringify(p));
      return true;
    } catch (e) { return false; }
  }

  function blank() {
    return {
      v: 1,
      updated: Date.now(),
      sweatRateMl: null,
      sweatSource: null,     // 'test' (svedtest-siden) | 'manual' (guidens slider)
      sweatMeasuredAt: null,
      sweatConditions: null, // 'koldt' | 'koeligt' | 'varmt' (fra svedtesten)
      sodium: null,          // 'lav' | 'normal' | 'salt' (fra screening)
      stomach: null,         // reserveret til R4/R6
      caffeine: null         // reserveret til R4/R6
    };
  }

  function get() { return read(); }

  function getSweatRate() {
    var p = read();
    return p && validSweat(p.sweatRateMl) ? p.sweatRateMl : null;
  }

  function set(patch) {
    if (!patch || typeof patch !== 'object') return false;
    var p = read() || blank();
    var touched = false;
    for (var i = 0; i < FIELDS.length; i++) {
      var k = FIELDS[i];
      if (Object.prototype.hasOwnProperty.call(patch, k)) {
        p[k] = patch[k];
        touched = true;
      }
    }
    if (!touched) return false;
    p.updated = Date.now();
    return write(p);
  }

  function setSweatRate(ml, source, conditions) {
    if (ml !== null && !validSweat(ml)) return false;
    var cond = (conditions === 'koldt' || conditions === 'koeligt' || conditions === 'varmt')
      ? conditions : null;
    return set({
      sweatRateMl: ml,
      sweatSource: ml === null ? null : (source === 'test' ? 'test' : 'manual'),
      sweatMeasuredAt: source === 'test' && ml !== null ? Date.now() : null,
      sweatConditions: ml === null ? null : cond
    });
  }

  function getSodium() {
    var pr = read();
    return pr && (pr.sodium === 'salt' || pr.sodium === 'normal' || pr.sodium === 'lav')
      ? pr.sodium : null;
  }

  // FASE 4.8.0: gem screeningens niveau. null rydder feltet —
  // atleten ejer sine tal, også retten til at slette dem.
  function setSodium(level) {
    if (level === null) return set({ sodium: null });
    if (level !== 'lav' && level !== 'normal' && level !== 'salt') return false;
    return set({ sodium: level });
  }

  function clearSweatRate() {
    return set({ sweatRateMl: null, sweatSource: null, sweatMeasuredAt: null, sweatConditions: null });
  }

  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  window.SportEnergyProfile = {
    KEY: KEY,
    get: get,
    getSweatRate: getSweatRate,
    getSodium: getSodium,
    setSodium: setSodium,
    set: set,
    setSweatRate: setSweatRate,
    clearSweatRate: clearSweatRate,
    clear: clear
  };
})();